import Vue from 'vue'
import Vuex from 'vuex'

import COVER from '@/utils/COVER'
import COVERAPP from '@/utils/COVERAPP'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        aid: '', // 活动id 
        musicPaused: false, // 音乐播放状态
        userInfo: {}, // 用户信息
        shareData: {}, // 分享信息
        dialogData: null, // 弹框数据
        activityData: null, // 活动数据
        pageLoading: true, //加载动画
        toastData: null, //toast数据
    },
    mutations: {
        SET_MUSICPAUSED(state, flag) {
            state.musicPaused = flag
        },
        SET_USERINFO(state, data) {
            state.userInfo = data
        },
        SET_SHAREDATA(state, data) {
            state.shareData = data
        },
        SET_DIALOGDATA(state, data) {
            state.dialogData = data
        },
        SET_ACTIVITYDATA(state, data) {
            state.activityData = data
        },
        SET_AID(state, data) {
            state.aid = data
        },
        SET_PAGELOADING(state, flag) {
            state.pageLoading = flag
        },
        setToastData(state, data) {
            state.toastData = data
        },
    },
    actions: {
        setPageLoadingAsync({ commit, state }, flag) {
            commit('setPageLoading', flag)
        },
        setDialogDataAsync({ commit, state }, data) {
            commit('SET_DIALOGDATA', data)
        }
    }
})
